import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Rss } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const SubscribeForm = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    try {
      await api.post("/subscribe", { email: email.trim() });
      setEmail("");
      toast.success("Te-ai abonat! Vei primi fiecare însemnare nouă pe email.");
    } catch (err) {
      toast.error(formatApiError(err, "Nu am putut înregistra abonarea"));
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-5" data-testid="subscribe-form">
      <p className="text-xs uppercase tracking-[0.25em] text-[var(--sun)]">Primește însemnările pe email</p>
      <div className="mt-3 flex max-w-md items-center gap-2">
        <div className="relative flex-1">
          <Mail className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#F8F3EC]/40" strokeWidth={1.6} />
          <input
            type="email"
            required
            data-testid="footer-subscribe-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="emailul tău"
            className="w-full rounded-full border border-[#F8F3EC]/20 bg-[#0D0907]/10 py-2.5 pl-10 pr-4 text-sm text-[#F8F3EC] outline-none placeholder:text-[#F8F3EC]/40 focus:border-[var(--sun)]"
          />
        </div>
        <button
          type="submit"
          disabled={sending}
          data-testid="footer-subscribe-btn"
          className="rounded-full bg-[var(--accent)] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-transform hover:-translate-y-0.5 active:scale-95 disabled:opacity-60"
        >
          {sending ? "..." : "Mă abonez"}
        </button>
      </div>
      <a
        href="https://la-cafea-fara-menajamente.ro/api/rss.xml"
        data-testid="subscribe-rss-link"
        className="mt-3 inline-flex items-center gap-1.5 text-xs text-[#F8F3EC]/60 transition-colors hover:text-[var(--sun)]"
      >
        <Rss className="h-3.5 w-3.5" strokeWidth={1.8} /> sau urmărește prin RSS (Feedly, Inoreader…)
      </a>
    </form>
  );
};

export const Footer = () => (
  <footer data-testid="site-footer" className="grain-dark relative mt-24 overflow-hidden bg-[var(--deep)]">
    <div className="relative mx-auto flex max-w-6xl flex-col gap-8 px-6 py-14 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="font-serif text-2xl font-medium text-[#F8F3EC]">La Cafea, Fără Menajamente</p>
        <p className="mt-2 max-w-md text-sm text-[#F8F3EC]/60">
          Păreri spuse pe șleau — despre oameni, relații, viața de adult
          și tot ce nu ne place să recunoaștem. Fără menajamente.
        </p>
        <SubscribeForm />
      </div>
      <div className="flex flex-col items-start gap-2 text-xs uppercase tracking-[0.25em] text-[#F8F3EC]/70 sm:items-end">
        <span>Scris cu cafea tare și fără mănuși</span>
        <a
          href="https://la-cafea-fara-menajamente.ro/api/rss.xml"
          data-testid="footer-rss-link"
          className="inline-flex items-center gap-1.5 transition-colors hover:text-[var(--sun)]"
        >
          <Rss className="h-3.5 w-3.5" strokeWidth={1.8} /> Flux RSS
        </a>
        <Link to="/login" data-testid="footer-login-link" className="transition-colors hover:text-[var(--sun)]">
          Atelier &rarr;
        </Link>
      </div>
    </div>
    <div className="pointer-events-none absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-[color-mix(in_srgb,var(--coral)_25%,transparent)] blur-3xl" />
    <div className="pointer-events-none absolute -top-24 left-1/3 h-56 w-56 rounded-full bg-[color-mix(in_srgb,var(--accent)_15%,transparent)] blur-3xl" />
  </footer>
);

export default Footer;
